<template>
  <div
    v-cloak
    v-loading.fullscreen.lock="dataLoading"
    element-loading-text="Loading, please wait..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-dialog
      @opened="openDialog"
      title="Config Ticket Type By Role"
      :visible.sync="configTicketTypeVisible"
      :close-on-click-modal="false"
      :center="true"
      width="800px"
      size="small"
      @closed="closeDialog"
    >
      <div class="body">
        <p class="title">Config Role Name: {{rowVal.role_name}}</p>
        <p class="title">Select Ticket Type:</p>
        <el-row :gutter="16">
          <el-col :span="12" v-for="(item,index) in list" :key="index">
            <div class="grid-content">
              <el-checkbox v-model="item.checked">{{item.name}}</el-checkbox>
            </div>
          </el-col>
        </el-row>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="save">Save</el-button>
        <el-button @click="configTicketTypeVisible = false">close</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rowVal: {},
      configTicketTypeVisible: false,
      dataLoading: false,
      list: []
    };
  },
  computed: {},
  created() {
    this.list = [
      {
        id:1,
        name: "aaaaaa aaaaaaaaaaaaaa aaaaa",
        checked: false
      },
      {
          id:2,
        name: "bbbbbb bbbbbbb bbbbbb bbbbb",
        checked: false
      },
      {
          id:3,
        name: "ccccccc cccccc ccccccc cccc",
        checked: true
      },
      {
          id:4,
        name: "ddddd ddddddddd dddddddd ddddd",
        checked: false
      },
      {
          id:5,
        name: "eeeee eeeee eeeee eeeeeee eeeee",
        checked: true
      },
      {
          id:6,
        name: "fffffff ffffff fffffffffffff fffffffff",
        checked: false
      }
    ];
  },

  methods: {
    closeDialog() {},
    //显示弹窗
    showConfigTicketTypeByRole(row) {
      this.rowVal = row;
      this.configTicketTypeVisible = true;
      console.log(this.rowVal, "showConfigTicketTypeByRole");
    },
    hideConfigRoleFunction() {
      this.configTicketTypeVisible = false;
    },
    save() {
      console.log(this.list ,"save");
      //    let checkedStructure = this.$refs.treeSelection.getCheckedNodesForReadWrite(false);
      //    console.log(checkedStructure);
      //    let roleFuntionList = {};
      //    let funcitonList = [];
      //     roleFuntionList.roleId = this.rowVal.id;
      //    checkedStructure.forEach(v =>{
      //      let item = {};
      //      item.roleId =
      //      item.functionId = v.id;
      //      item.isWrite = v.writeChecked;
      //      item.isRead = v.readChecked;
      //      funcitonList.push(item);
      //    });
      //     roleFuntionList.roleFunctionPermissions = funcitonList;

      //     let url = this.baseUrl + 'mdm-common/acs/role-function/save';
      //     this.dataLoading = true;
      //     this.http.post(url,roleFuntionList).then(resp =>{
      //       this.$message.success('Successful operation ');
      //       this.configTicketTypeVisible = false;
      //       this.dataLoading = false;
      //       this.$emit("saveSuccess");
      //     } ).catch(error => {
      //       this.dataLoading = false;
      //       console.info(error);
      //       this.$emit("saveFail");
      //     });
    },
    //打开弹窗之后
    openDialog() {
      console.log("openDialog");
      // this.dataLoading = true;
      // let url = this.baseUrl + 'mdm-common/acs/role-function/get-role-function-permission?role_id='+this.rowVal.id;
      // this.http.get(url).then(resp => {
      //   this.dataLoading = false;
      //   let data = resp.data;
      //   if(data){
      //     this.$refs.treeSelection.init(data, 'functionName', 'isRead', 'isWrite');
      //   }else{
      //     this.$message.warning("Empty Data! ");
      //   }
      // }).catch(error =>{
      //   this.dataLoading = false;
      // })
    }
  }
};
</script>

<style lang="scss" scoped>
[v-cloak] {
  display: none;
}
.el-dialog .el-dialog__body .body {

}
</style>



// WEBPACK FOOTER //
// src/view/acs/role/dialog/config_ticket_type_by_role.vue